'use client'

import { Input } from '@/components/ui/input'
import { FieldShell, premiumControlClass } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function PhoneField({ props, mode, value, onChange, error }: AnswerableFieldProps<'Phone', string>) {
  const isPreview = mode === 'preview'
  return (
    <FieldShell
      mode={mode}
      htmlFor={props.id}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <Input
        id={props.id}
        type="tel"
        className={premiumControlClass}
        placeholder="(555) 123-4567"
        readOnly={isPreview}
        value={isPreview ? '' : typeof value === 'string' ? value : ''}
        onChange={isPreview ? undefined : e => onChange?.(e.target.value)}
      />
    </FieldShell>
  )
}
